import { useSelector } from 'react-redux';
import { getAvailableTabs } from '@/store/fundDetails';
import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import CumulativeTable from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/CumulativeTable';
import CumulativeQuarterlyTable from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/CumulativeQuarterlyTable';

const FundDetailsCumulativeTab = () => {
  const availableTabs = useSelector(getAvailableTabs);
  return (
    <FundDetailsTabRow fullWidth className="mt-4">
      <CumulativeTable />
      {availableTabs.performanceTab.cumulativeQuarterlyTab && (
        <CumulativeQuarterlyTable className="mt-4" />
      )}
    </FundDetailsTabRow>
  );
};

export default FundDetailsCumulativeTab;
